import { useAuth } from "@entities/auth";
import {
  BreifInfluencerV2StatusEnum,
  nextActionToTakeEnum,
  SORT_ORDER,
} from "@entities/brief/lib/constants";
import { useUpdateEstView } from "@entities/brief/lib/hooks/useAddEstViews";
import { useUpdatePaymentTerms } from "@entities/brief/lib/hooks/useAddPaymentTerms";
import { useAssignBriefPoc } from "@entities/brief/lib/hooks/useAssignBriefPoc";
import { useGetBriefInfluencerSearchFacetsWithoutBriefId } from "@entities/brief/lib/hooks/useGetBriefInfluencerSearchFacetsWithoutBriefId";
import { useGetBriefInfluencersV2withoutBriefId } from "@entities/brief/lib/hooks/useGetBriefInfluencersV2withoutBriefId";
import { useBriefStore } from "@pages/layout/BriefLayout/lib/useLayoutStore";
import {
  IAssignedPOC,
  IBriefInfluencerSearchRequestV2WithoutBriefId,
  IBriefInfluencerV2,
  IInfluencerContact,
} from "@shared/lib/types/briefInfluencerV2";
import { Table } from "@shared/ui";
import { ColumnSortUI } from "@shared/ui/filters/ColumnSortUI";
import { ColumnFilterWrapper } from "@shared/ui/filters/ColumnFilterWrapper";
import { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";

import {
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
  InfoCircleOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import { usePurchaseInfluencer } from "@entities/brief/lib/hooks/usePurchaseInfluencer";
import { usePurchaseNonProfitable } from "@entities/brief/lib/hooks/usePurchaseNonProfitable";
import { SelectContact } from "@entities/brief/ui/Influencer/v2/SelectContact";
import BriefContactFilter from "@features/BriefContactFilter/BriefContactFilter";
import { ConfirmPurchase } from "@features/ConfirmPurchase";
import { AssignPricingModal } from "@features/assignPricingModal";
import { BrandCommercial } from "@features/brandCommercials/BrandCommercials";
import { BriefCreatorColumn } from "@features/breifCreatorColumn/BriefCreatorColumn";
import { BriefInfluencerCommercials } from "@features/briefInfluencerCommercials/BriefInfluencerCommercials";
import { BriefPocFilter } from "@features/briefPocFilter/BriefPocFilter";
import { BriefTimelinePopOver } from "@features/briefTimeline/BriefTimelinePopOver";
import { InfluencerCommercial } from "@features/infleuncerCommercials/InfluencerCommercials";
import { SocialMediaInfluencerComp } from "@features/socialMediaInfluencer/SocialMediaInfluencerComp";
import { ToastService } from "@shared/lib/services";
import { formatData } from "@shared/lib/utils/formatData";
import { Button } from "@shared/ui/Button";
import SelectInput from "@shared/ui/SelectInput";
import { TextWithTooltip } from "@shared/ui/TextWithTooltip";
import { BriefBrandFilter } from "@shared/ui/filters/BriefBrandFilter";
import DateRangeFilter from "@shared/ui/filters/DateRangeFilter";
import InfluencerCommercialFilter from "@shared/ui/filters/InfluencerCommercialFilter.tsx";
import {
  Col,
  Divider,
  Drawer,
  Dropdown,
  Flex,
  InputNumber,
  Menu,
  Modal,
  Row,
  Space,
  Tag,
  Tooltip,
} from "antd";
import Search from "antd/es/input/Search";
import { format, formatDate } from "date-fns";
import styles from "./styles.module.scss";

export function BriefPricingTracking() {
  const { briefId, setBriefIdOnly, brief } = useBriefStore();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const [brandId, setBrandId] = useState<string>("");

  const [selectedBriefIds, setSelectedBriefIds] = useState<string>("");

  const { isRishabEmail, beUser } = useAuth();

  const [paymnetTermsProps, setpaymnetTermsProps] = useState<{
    briefInfluencerId: string;
    paymentTerms: string;
  }>({
    briefInfluencerId: "",
    paymentTerms: "",
  });
  const [estViewsProps, setestViewsProps] = useState<{
    briefInfluencerId: string;
    estViews: number;
  }>({
    briefInfluencerId: "",
    estViews: 0,
  });

  const [deliverableModalProps, setDeliverableModalProps] = useState<{
    visible: boolean;
    deliverableId?: string;
    briefInfluencerIds: string[];
    type: "view" | "create";
  }>({
    visible: false,
    deliverableId: "",
    briefInfluencerIds: [],
    type: "create",
  });

  const [page, setPage] = useState(1); // default if not present
  const [pageSize, setPageSize] = useState(50);
  const [filters, setFilters] =
    useState<IBriefInfluencerSearchRequestV2WithoutBriefId>({
      page: 1,
      limit: 10,
      isBrandDeclined: undefined,
      isBrandNewCostPending: undefined,
      isConfirmationSent: undefined,
      isConfirmed: undefined,
      isCreatorDeclined: undefined,
      isCreatorOnboardPending: undefined,
      isDeliverablesPending: undefined,
      isInitialInfluencerCostPending: undefined,
      isNewCommericalRequested: undefined,
      searchQuery: "",
      isPrimaryContactAdded: undefined,

      statuses: [
        BreifInfluencerV2StatusEnum.Pricing,
        BreifInfluencerV2StatusEnum.Shortlisted,
      ],
    });

  const { page: PageNo, ...restFilters } = filters;
  const [selectedInfluencer, setSelectedInfluencer] = useState<{
    visible: boolean;
    props?: {
      username: string;
      platform: string;
      toOpenInfluencer?: boolean;
      creatorInfo: {
        name?: string;
        image?: string;
        username?: string;
      };
    };
  }>({ visible: false, props: undefined });

  const [pricingPocModalProps, setPricingPocModalProps] = useState<{
    visible: boolean;
    briefInfluencerId: string[];
    selectedAssignedTo?: IAssignedPOC["assignedTo"];
  }>({
    visible: false,
    briefInfluencerId: [],
    selectedAssignedTo: undefined,
  });

  const [conatcsModalProps, setContactsModalProps] = useState<{
    visible: boolean;
    briefInfluencerId: string;
    conatcts: IInfluencerContact[];
    addContactOnly?: boolean;
    initialContact: IInfluencerContact | null;
    creatorInfo:
      | {
          name: string;
          dp: string;
          rating: number;
        }
      | undefined;
  }>({
    visible: false,
    briefInfluencerId: "",
    creatorInfo: undefined,
    conatcts: [],
    addContactOnly: false,
    initialContact: null,
  });

  const [infCommercialsModalProps, setInfluencerModalProps] = useState<{
    visible: boolean;
    briefInfluencer?: IBriefInfluencerV2;
    type: "view" | "create-new" | "create";
  }>({
    visible: false,
    type: "create",
  });

  const [brandCommercialsModalProps, setBrandluencerModalProps] = useState<{
    visible: boolean;
    briefInfluencer?: IBriefInfluencerV2;
    type: "view" | "create-new";
  }>({
    visible: false,
    type: "view",
  });

  const { assignPricingPoc, isAssigning } = useAssignBriefPoc(briefId);

  const openPricingPocModal = (
    briefInfluencerId: string[] | string,
    assignedTo?: IAssignedPOC["assignedTo"]
  ) => {
    setPricingPocModalProps({
      visible: true,
      briefInfluencerId: Array.isArray(briefInfluencerId)
        ? briefInfluencerId
        : [briefInfluencerId],
      selectedAssignedTo: assignedTo,
    });
  };

  const [purchaseModalProps, setPurhcaseModalProps] = useState<{
    visible: boolean;
    briefInfluencers?: IBriefInfluencerV2[];
  }>({
    visible: false,
  });

  const { briefInfluencers, isFetching, refetch } =
    useGetBriefInfluencersV2withoutBriefId({
      ...filters,
      page: page,
      limit: pageSize,
      brandIds: brandId ? [brandId] : undefined,
      briefId: selectedBriefIds ? selectedBriefIds : undefined,
    });
  const { searchFacets } = useGetBriefInfluencerSearchFacetsWithoutBriefId([
    BreifInfluencerV2StatusEnum.Pricing,
    BreifInfluencerV2StatusEnum.Shortlisted,
  ]);

  const { updatePaymentTerms, isUpdating } = useUpdatePaymentTerms(
    undefined,
    () => {
      refetch();
      setpaymnetTermsProps({
        briefInfluencerId: "",
        paymentTerms: "",
      });
    }
  );

  const { updateEstView, isUpdating: isEstViewUpdating } = useUpdateEstView(
    undefined,
    () => {
      refetch();
      setestViewsProps({
        briefInfluencerId: "",
        estViews: 0,
      });
    }
  );

  const handlePageChange = (page: number, pageSize: number) => {
    setPage(page);
    setPageSize(pageSize);
  };

  const BriefPricingPOCOptions = [
    ...(searchFacets?.assignedPricingPocV2
      ? searchFacets?.assignedPricingPocV2
      : []),
    {
      _id: "unassigned",
      user: {
        _id: "unassigned",
        firstName: "Unassigned",
        lastName: "",
      },
    },
  ];

  const [purchaseResult, setPurchaseResult] = useState<{
    nextActionToTake: string;
    result: {
      status: string;
      reason: string;
      briefInfluencer: IBriefInfluencerV2;
    }[];
  } | null>(null);
  const [showCannotPurchaseModal, setShowCannotPurchaseModal] = useState(false);
  const [showNonProfitableModal, setShowNonProfitableModal] = useState(false);

  const { isPurchased, isPurchasing, purchase } = usePurchaseInfluencer(
    briefId,
    (data) => {
      setPurchaseResult(data);
      if (data.nextActionToTake === nextActionToTakeEnum.CANNOT_PURCHASE) {
        setShowCannotPurchaseModal(true);
      } else if (
        data.nextActionToTake === nextActionToTakeEnum.NON_PROFITABLE
      ) {
        setShowNonProfitableModal(true);
      } else {
        ToastService.success("Purchased");
      }
    }
  );
  const {
    purchaseNonProfitable,
    isPurchasingNonProfitable,
    isPurchasedNonProfitable,
  } = usePurchaseNonProfitable(briefId);

  useEffect(() => {
    handlePageChange(1, pageSize);
  }, [filters]);

  useEffect(() => {
    if (isPurchased) {
      setPurhcaseModalProps({
        visible: false,
        briefInfluencers: [],
      });
    }
  }, [isPurchased]);
  useEffect(() => {
    if (isPurchasedNonProfitable) {
      ToastService.success("Purchased Non Profitable");
      setShowNonProfitableModal(false);
    }
  }, [isPurchasedNonProfitable]);
  const columns: ColumnsType<IBriefInfluencerV2> = [
    {
      title: "Creator",
      dataIndex: "influencerName",
      key: "creator",
      fixed: "left",

      className: styles.actionsColumn,
      render: (text, record) => (
        <BriefCreatorColumn
          influencerId={record.influencerId}
          influencerName={record.influencerName}
          username={record.socialMedia?.username}
          platform={record.socialMedia?.platform}
          profilePicUrl={record.socialMedia?.profilePicUrl}
          link={record.socialMedia?.link}
          isCreatorDeclined={record.isCreatorDeclined}
          isBrandDeclined={record.isBrandDeclined}
          creatorDeclinedReason={record.creatorDeclinedReason}
          brandDeclinedReason={record.brandDeclinedReason}
        />
      ),
    },
    {
      title: "Brief Info",
      render: (text, record) => (
        <Flex vertical gap={2}>
          <TextWithTooltip text={record.brief?.name} limit={15} />
          <TextWithTooltip text={record.brand?.name} limit={15} />
        </Flex>
      ),
      filterDropdown: (props: { confirm: () => void; close: () => void }) => {
        return (
          <BriefBrandFilter
            props={props}
            selectedBrandId={brandId}
            selectedBriefId={selectedBriefIds}
            handlePropsChange={(props: any) => {
              setBrandId(props.brandId || "");
              setSelectedBriefIds(props.briefId || "");
            }}
          />
        );

        // Return null for other field types to avoid undefined filter dropdown
      },
    },

    {
      title: "Followers",
      dataIndex: "followers",
      key: "followers",
      width: 100,
      filterCount: filters.sortByFollowers ? 1 : 0,
      filterDropdownProps: { destroyPopupOnHide: true },
      filterDropdown: (props: { confirm: () => void; close: () => void }) => (
        <ColumnFilterWrapper
          title="Followers"
          confirm={props.confirm}
          close={props.close}
          hasSort={true}
          hasFilter={false}
          sortActive={!!filters.sortByFollowers}
          sortDirection={
            filters.sortByFollowers === SORT_ORDER.ASCEND ? "asc" : "desc"
          }
          onReset={() => {
            setFilters((prev) => {
              const next = { ...prev };
              delete next.sortByFollowers;
              return next;
            });
            props.confirm();
          }}
          onApply={() => props.confirm()}
        >
          <ColumnSortUI
            sortActive={!!filters.sortByFollowers}
            sortDirection={
              filters.sortByFollowers === SORT_ORDER.ASCEND ? "asc" : "desc"
            }
            onSortChange={(dir) => {
              setFilters((prev) => {
                const next = { ...prev };
                if (!dir) {
                  delete next.sortByFollowers;
                } else {
                  next.sortByFollowers =
                    dir === "asc" ? SORT_ORDER.ASCEND : SORT_ORDER.DESCEND;
                }
                return {
                  ...next,
                  sortByUpdatedAt: undefined,
                  sortByCreatedAt: undefined,
                };
              });
              props.confirm();
            }}
          />
        </ColumnFilterWrapper>
      ),
      render: (followers: number) => (
        <span>{followers ? formatData(followers, "a") : "--"}</span>
      ),
    },

    {
      title: "Contact",
      key: "contact",
      filterDropdown: (props: { confirm: () => void; close: () => void }) => {
        return (
          <BriefContactFilter
            {...props}
            filters={filters}
            setFilters={setFilters}
          />
        );
      },
      render: (_, record: IBriefInfluencerV2) => {
        const renderDropdown = () => {
          return (
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item>
                    <Button
                      type="link"
                      icon={<EditOutlined />}
                      onClick={() => {
                        setContactsModalProps({
                          initialContact: record?.primaryContact || null,
                          addContactOnly: true,
                          visible: true,
                          briefInfluencerId: record._id,
                          conatcts: record?.influencer?.contacts || [],
                          creatorInfo: {
                            name: record.socialMedia.username,
                            dp: record.socialMedia?.profilePicUrl,
                            rating: record.influencer?.avgReview || 0,
                          },
                        });
                      }}
                    >
                      Change Contact
                    </Button>
                  </Menu.Item>
                </Menu>
              }
              trigger={["click", "hover"]}
              placement="bottomRight"
            >
              <Button icon={<MoreOutlined />} type="text" />
            </Dropdown>
          );
        };
        if (!record?.isPrimaryContactAdded) {
          return (
            <Button
              size="small"
              onClick={() =>
                setContactsModalProps({
                  initialContact: record?.primaryContact || null,
                  addContactOnly: true,
                  visible: true,
                  briefInfluencerId: record._id,
                  conatcts: record?.influencer?.contacts || [],
                  creatorInfo: {
                    name: record.socialMedia.username,
                    dp: record.socialMedia?.profilePicUrl,
                    rating: record.influencer?.avgReview || 0,
                  },
                })
              }
            >
              Add Contact
            </Button>
          );
        }
        if (record?.primaryContact?.agencyUser) {
          return (
            <div className={styles.aTile}>
              <Space>
                <span className={styles.cName}>
                  {record?.primaryContact?.agency?.name}
                </span>
                <span className={styles.aRole}>Agency</span>
                {renderDropdown()}
              </Space>
              <Space>
                <span className={styles.cType}>
                  {record?.primaryContact?.agencyUser?.name}
                </span>
                /
                <span className={styles.numb}>
                  {record?.primaryContact?.agencyUser?.phoneNumber
                    ? `${record?.primaryContact?.agencyUser?.countryCode} ${record?.primaryContact?.agencyUser?.phoneNumber}`
                    : record?.primaryContact?.agencyUser?.emailId}
                </span>
              </Space>
            </div>
          );
        }

        return (
          <div className={styles.aTile}>
            <Space>
              <span className={styles.cName}>
                {record?.primaryContact?.name}
              </span>
              {renderDropdown()}
            </Space>
            <Space>
              <span className={styles.cType}>
                {record?.primaryContact?.type}
              </span>
              /
              <span className={styles.numb}>
                {record?.primaryContact?.phoneNumber
                  ? `${record?.primaryContact?.countryCode} ${record?.primaryContact?.phoneNumber}`
                  : record?.primaryContact?.emailId}
              </span>
            </Space>
          </div>
        );
      },
    },
    {
      title: "Pricing POC",
      key: "pricingPoc",
      filterDropdown: (props: { confirm: () => void; close: () => void }) => {
        return (
          <BriefPocFilter
            {...props}
            filters={filters}
            setFilters={setFilters}
            pocOptions={BriefPricingPOCOptions}
          />
        );
      },
      render: (_, record) => {
        if (record.assignedPricingPocV2) {
          return (
            <Space>
              <span>
                {record.assignedPricingPocV2?.assignedToUser?.firstName}{" "}
                {record.assignedPricingPocV2?.assignedToUser?.lastName}
              </span>
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item>
                      <Button
                        type="link"
                        icon={<EditOutlined />}
                        onClick={() => {
                          openPricingPocModal(
                            record._id,
                            record.assignedPricingPocV2?.assignedToUser
                          );
                        }}
                      >
                        Change Pricing POC
                      </Button>
                    </Menu.Item>
                  </Menu>
                }
                trigger={["click", "hover"]}
                placement="bottomRight"
              >
                <Button icon={<MoreOutlined />} type="text" />
              </Dropdown>
            </Space>
          );
        }
        return (
          <Button
            size="small"
            onClick={() =>
              openPricingPocModal(
                record._id,
                record.assignedPricingPocV2?.assignedToUser
              )
            }
          >
            Assign Pricing POC
          </Button>
        );
      },
    },

    {
      title: "Payment Terms",
      key: "paymentTerms",
      width: 120,
      render: (_: any, record: IBriefInfluencerV2) => {
        const isEditingField =
          paymnetTermsProps.briefInfluencerId === record._id;
        if (isEditingField) {
          const addonAfter = (
            <Space>
              <Button
                icon={<CheckOutlined />}
                type="text"
                style={{ padding: 0 }}
                size="small"
                loading={isUpdating}
                onClick={() =>
                  updatePaymentTerms({
                    briefInfluencerId: record._id,
                    paymentTerms: paymnetTermsProps.paymentTerms,
                  })
                }
              />
              <Button
                icon={<CloseOutlined />}
                type="text"
                size="small"
                style={{ padding: 0 }}
                onClick={() =>
                  setpaymnetTermsProps({
                    briefInfluencerId: "",
                    paymentTerms: "",
                  })
                }
              />
            </Space>
          );
          return (
            <Space>
              <div style={{ width: "150px" }}>
                <SelectInput
                  placeholder="Select payment terms"
                  allowClear
                  showSearch
                  onSearch={() => {}}
                  value={paymnetTermsProps.paymentTerms}
                  isFetching={false}
                  dropdownOpen={dropdownOpen}
                  setDropdownOpen={setDropdownOpen}
                  options={
                    searchFacets?.paymentTerms?.map((item) => ({
                      label: item._id,
                      value: item._id,
                    })) || []
                  }
                  onchange={(value) =>
                    setpaymnetTermsProps({
                      briefInfluencerId: record._id,
                      paymentTerms: value as string,
                    })
                  }
                  newItem={{
                    placeholder: "Enter a new payment term",
                    addNewItem: (item) =>
                      setpaymnetTermsProps({
                        briefInfluencerId: record._id,
                        paymentTerms: item,
                      }),
                    addButtonText: "Add payment term",
                  }}
                />
              </div>
              {addonAfter}
            </Space>
          );
        }

        return (
          <div
            className={styles.editableCell}
            style={{ display: "flex", alignItems: "center" }}
          >
            <span
              onClick={() =>
                setpaymnetTermsProps({
                  paymentTerms: record?.paymentTerms || "",
                  briefInfluencerId: record._id,
                })
              }
            >
              {" "}
              {record?.paymentTerms || "--"}
            </span>
          </div>
        );
      },
    },
    {
      title: "Est. Views",
      key: "estViews",
      width: 120,
      render: (_: any, record: IBriefInfluencerV2) => {
        const isEditingField = estViewsProps.briefInfluencerId === record._id;
        if (isEditingField) {
          const addonAfter = (
            <Space>
              <Button
                icon={<CheckOutlined />}
                type="text"
                style={{ padding: 0 }}
                size="small"
                loading={isEstViewUpdating}
                onClick={() =>
                  updateEstView({
                    briefInfluencerId: record._id,
                    estViews: estViewsProps.estViews,
                  })
                }
              />
              <Button
                icon={<CloseOutlined />}
                type="text"
                size="small"
                style={{ padding: 0 }}
                onClick={() =>
                  setestViewsProps({
                    briefInfluencerId: "",
                    estViews: 0,
                  })
                }
              />
            </Space>
          );
          return (
            <Space>
              <div>
                <InputNumber
                  value={estViewsProps.estViews}
                  onChange={(value) =>
                    setestViewsProps({
                      briefInfluencerId: record._id,
                      estViews: (value as number) || 0,
                    })
                  }
                />
              </div>
              {addonAfter}
            </Space>
          );
        }

        return (
          <div
            className={styles.editableCell}
            style={{ display: "flex", alignItems: "center" }}
          >
            <span
              onClick={() =>
                setestViewsProps({
                  estViews: record?.estViews || 0,
                  briefInfluencerId: record._id,
                })
              }
            >
              {record?.estViews ? formatData(record?.estViews, "a") : "--"}
            </span>
          </div>
        );
      },
    },
    {
      title: "Influencer Commercials",
      key: "influencerCommercials",
      hidden: beUser?.demoMode,

      render: (_, record) => {
        if (record.isBrandDeclined) {
          return (
            <Tooltip title={record?.brandDeclinedReason}>
              <Button
                type="link"
                danger
                icon={<InfoCircleOutlined />}
                className={styles.tooltipButton}
              >
                Brand Declined
              </Button>
            </Tooltip>
          );
        }
        if (record.isCreatorDeclined) {
          return (
            <Tooltip title={record?.creatorDeclinedReason}>
              <Button
                type="link"
                danger
                icon={<InfoCircleOutlined />}
                className={styles.tooltipButton}
              >
                Creator Declined
              </Button>
            </Tooltip>
          );
        }

        return <BriefInfluencerCommercials briefInfluencer={record} />;
      },
      filterDropdown: (props: { confirm: () => void; close: () => void }) => {
        return (
          <InfluencerCommercialFilter
            type="all"
            props={props}
            placeholder={`Select Date Range`}
            selectedRange={filters.influencerCost?.date}
            selectedStageInitial={filters.influencerCost?.offerStatus || []}
            handlePropsChange={(props) => {
              setFilters((prev) => ({
                ...prev,
                influencerCost: {
                  ...prev.influencerCost,
                  date: props.range,
                  offerStatus: props.stage,
                  createdByType: props.createdByType,
                },
              }));
            }}
          />
        );

        // Return null for other field types to avoid undefined filter dropdown
      },
    },
    ...(!isRishabEmail
      ? [
          {
            title: "Brand Price",
            key: "brandPrice",
            minWidth: 120,
            render: (_: any, record: IBriefInfluencerV2) => {
              if (record.isBrandDeclined) {
                return (
                  <Tooltip title={record?.brandDeclinedReason}>
                    <Button
                      type="link"
                      danger
                      icon={<InfoCircleOutlined />}
                      className={styles.tooltipButton}
                    >
                      Brand Declined
                    </Button>
                  </Tooltip>
                );
              }
              if (record.isCreatorDeclined) {
                return (
                  <Tooltip title={record?.creatorDeclinedReason}>
                    <Button
                      type="link"
                      danger
                      icon={<InfoCircleOutlined />}
                      className={styles.tooltipButton}
                    >
                      Creator Declined
                    </Button>
                  </Tooltip>
                );
              }

              if (record?.brandCost) {
                return (
                  <div className={styles.influencerCostCell}>
                    <BriefTimelinePopOver
                      briefInfluencer={record}
                      type="brand"
                    />
                    <div className={styles.influencerCostInfo}>
                      <div className={styles.influencerCostAmount}>
                        {record.brandCost.cost}
                      </div>
                      <div className={styles.influencerCostMeta}>
                        {record.brandCost.createdAt
                          ? formatDate(record.brandCost.createdAt, "dd/MM/yy")
                          : "--"}{" "}
                        {record.brandCost.createdBy?.firstName}
                      </div>
                    </div>
                    <div className={styles.influencerCostActions}>
                      <Button
                        type="link"
                        className={styles.influencerCostView}
                        size="small"
                        onClick={() =>
                          setBrandluencerModalProps({
                            visible: true,
                            briefInfluencer: record,
                            type: "view",
                          })
                        }
                      >
                        View
                      </Button>
                      <Button
                        type="link"
                        className={styles.influencerCostView}
                        size="small"
                        onClick={() =>
                          setBrandluencerModalProps({
                            visible: true,
                            briefInfluencer: record,
                            type: "create-new",
                          })
                        }
                      >
                        Add new
                      </Button>
                    </div>
                  </div>
                );
              }
            },
          },
        ]
      : []),
    {
      title: "Brand CPV",
      key: "bcpv",
      render: (_, record) => {
        const cost = record.brandCost?.cost || 0;
        const views = record.estViews || 1;
        const cpv = views ? (cost / views).toFixed(2) : "--";
        return <span>{cpv}</span>;
      },
    },

    {
      title: "Deliverables",
      key: "deliverables",
      width: 120,
      render: (_, record) => {
        if (
          record?.deliverableV2 &&
          record.deliverableV2.purchaseItems &&
          record.deliverableV2.purchaseItems.length > 0
        ) {
          return (
            <Flex align="center" gap={2}>
              <span className={styles.deliverableSummary}>
                <TextWithTooltip
                  text={
                    record?.deliverableV2?.name ||
                    `Package - ${
                      record?.deliverableV2?.setNumber || ""
                    }`
                  }
                  limit={15}
                />{" "}
              </span>
              {/* <Flex vertical>
                <Button
                  type="link"
                  size="small"
                  className={styles.deliverableView}
                  onClick={() =>
                    setDeliverableModalProps({
                      visible: true,
                      deliverableId:
                        record?.deliverableV2?._id || "",
                      type: "view",
                      briefInfluencerIds: [record._id],
                    })
                  }
                >
                  View
                </Button>
              </Flex> */}
            </Flex>
          );
        }
        return <div>..</div>;
      },
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 100,
      filterCount: (filters.sortByCreatedAt ? 1 : 0) + (filters.createdAt?.from || filters.createdAt?.to ? 1 : 0),
      filterDropdownProps: {
        destroyPopupOnHide: true,
      },
      filterDropdown: (props: { confirm: () => void; close: () => void }) => {
        const sortUI = (
          <ColumnSortUI
            sortActive={!!filters.sortByCreatedAt}
            sortDirection={
              filters.sortByCreatedAt === SORT_ORDER.ASCEND
                ? "asc"
                : filters.sortByCreatedAt === SORT_ORDER.DESCEND
                  ? "desc"
                  : undefined
            }
            onSortChange={(dir) => {
              setFilters((prev) => ({
                ...prev,
                sortByCreatedAt:
                  dir === "asc"
                    ? SORT_ORDER.ASCEND
                    : dir === "desc"
                      ? SORT_ORDER.DESCEND
                      : undefined,
                sortByUpdatedAt: undefined,
                sortByFollowers: undefined,
              }));
            }}
            sortAscLabel="Earliest first"
            sortDescLabel="Latest first"
          />
        );
        return (
          <DateRangeFilter
            title="Created At"
            before={sortUI}
            props={props}
            placeholder="Select Date Range"
            selectedRange={filters.createdAt}
            handlePropsChange={(rangeProps) => {
              setFilters((prev) => ({
                ...prev,
                createdAt: rangeProps.range,
              }));
            }}
          />
        );
      },
      render: (createdAt: string) => (
        <span>
          {createdAt ? format(new Date(createdAt), "dd/MM/yyyy") : "--"}
        </span>
      ),
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: 100,
      filterCount: (filters.sortByUpdatedAt ? 1 : 0) + (filters.updatedAt?.from || filters.updatedAt?.to ? 1 : 0),
      filterDropdownProps: {
        destroyPopupOnHide: true,
      },
      filterDropdown: (props: { confirm: () => void; close: () => void }) => {
        const sortUI = (
          <ColumnSortUI
            sortActive={!!filters.sortByUpdatedAt}
            sortDirection={
              filters.sortByUpdatedAt === SORT_ORDER.ASCEND
                ? "asc"
                : filters.sortByUpdatedAt === SORT_ORDER.DESCEND
                  ? "desc"
                  : undefined
            }
            onSortChange={(dir) => {
              setFilters((prev) => ({
                ...prev,
                sortByUpdatedAt:
                  dir === "asc"
                    ? SORT_ORDER.ASCEND
                    : dir === "desc"
                      ? SORT_ORDER.DESCEND
                      : undefined,
                sortByCreatedAt: undefined,
                sortByFollowers: undefined,
              }));
            }}
            sortAscLabel="Earliest first"
            sortDescLabel="Latest first"
          />
        );
        return (
          <DateRangeFilter
            title="Updated At"
            before={sortUI}
            props={props}
            placeholder="Select Date Range"
            selectedRange={filters.updatedAt}
            handlePropsChange={(rangeProps) => {
              setFilters((prev) => ({
                ...prev,
                updatedAt: rangeProps.range,
              }));
            }}
          />
        );
      },
      render: (updatedAt: string) => (
        <span>
          {updatedAt ? format(new Date(updatedAt), "dd/MM/yyyy") : "--"}
        </span>
      ),
    },
  ];

  return (
    <>
      <div className={styles.card}>
        <div className={styles.recordLabel}>
          {briefInfluencers?.pagination?.totalCount || 0} Records found
        </div>
        <Row
          gutter={[15, 15]}
          justify={"space-between"}
          style={{ padding: "20px 10px" }}
        >
          <Col>
            <Search
              value={filters.searchQuery}
              onChange={(e) =>
                setFilters((prev) => ({ ...prev, searchQuery: e.target.value }))
              }
              placeholder="Search by influencer or username"
            />
          </Col>
        </Row>
        <Divider style={{ marginBottom: 20, marginTop: 0 }} />

        <Flex style={{ padding: "0px 10px 10px", gap: 12 }}>
          <Tag
            color={filters.isBrandFavourite === true ? "geekblue" : "default"}
            style={{ cursor: "pointer" }}
            onClick={() =>
              setFilters((prev) => ({
                ...prev,
                isBrandFavourite: prev.isBrandFavourite ? undefined : true,
              }))
            }
          >
            Favourite ({searchFacets?.isBrandFavourite})
          </Tag>
          <Tag
            color={
              filters.isCreatorOnboardPending === true ? "geekblue" : "default"
            }
            style={{ cursor: "pointer" }}
            onClick={() =>
              setFilters((prev) => ({
                ...prev,
                isCreatorOnboardPending:
                  prev.isCreatorOnboardPending === undefined ? true : undefined,
                awaitingPurchase: undefined,
                isBrandNewCostPending: undefined,
              }))
            }
          >
            No Contact ({searchFacets?.isCreatorOnboardPending})
          </Tag>
          <Tag
            color={filters.isNewCommericalRequested ? "geekblue" : "default"}
            style={{ cursor: "pointer" }}
            onClick={() =>
              setFilters((prev) => ({
                ...prev,
                isNewCommericalRequested: prev.isNewCommericalRequested
                  ? undefined
                  : true,
                awaitingPurchase: undefined,
                isBrandNewCostPending: undefined,
              }))
            }
          >
            New Commercials Requested ({searchFacets?.isNewCommericalRequested})
          </Tag>
          <Tag
            color={filters.isBrandNewCostPending ? "geekblue" : "default"}
            style={{ cursor: "pointer" }}
            onClick={() =>
              setFilters((prev) => ({
                ...prev,
                isBrandNewCostPending: prev.isBrandNewCostPending
                  ? undefined
                  : true,
                awaitingPurchase: undefined,
                isNewCommericalRequested: undefined,
              }))
            }
          >
            New brand price pending ({searchFacets?.isBrandNewCostPending})
          </Tag>
          <Tag
            color={filters.awaitingPurchase ? "geekblue" : "default"}
            style={{ cursor: "pointer" }}
            onClick={() =>
              setFilters((prev) => ({
                ...prev,
                awaitingPurchase: prev.awaitingPurchase ? undefined : true,
                isBrandNewCostPending: undefined,
                isNewCommericalRequested: undefined,
              }))
            }
          >
            Awaiting Purchase ({searchFacets?.awaitingPurchase})
          </Tag>

          <Divider
            type="vertical"
            style={{
              margin: "0px",
              backgroundColor: "rgba(0, 0, 0, 0.50)",
              height: "unset",
            }}
          />
          <Tag
            color={filters.isBrandDeclined ? "geekblue" : "default"}
            style={{ cursor: "pointer" }}
            onClick={() =>
              setFilters((prev) => ({
                ...prev,
                isBrandDeclined: prev.isBrandDeclined ? undefined : true,
              }))
            }
          >
            Brand Rejected ({searchFacets?.isBrandDeclined})
          </Tag>

          <Tag
            color={filters.isCreatorDeclined ? "geekblue" : "default"}
            style={{ cursor: "pointer" }}
            onClick={() =>
              setFilters((prev) => ({
                ...prev,
                isCreatorDeclined: prev.isCreatorDeclined ? undefined : true,
              }))
            }
          >
            Influencer Rejected ({searchFacets?.isCreatorDeclined})
          </Tag>
        </Flex>
        <div style={{ position: "relative" }}>
          <Table
            size="small"
            dataSource={briefInfluencers?.data}
            loading={isFetching}
            columns={columns}
            scroll={{ x: "max-content", y: 400 }}
            pagination={{
              pageSize: pageSize,
              current: page,
              total: briefInfluencers?.pagination?.totalCount,
              onChange: handlePageChange,
            }}
            onRow={(record) => {
              return {
                onClick: () => {
                  setBriefIdOnly(record.briefId);
                },
              };
            }}
          />
        </div>
      </div>
      <Drawer
        title="Influencer Details"
        open={selectedInfluencer.visible}
        width={1300}
        footer={null}
        destroyOnClose
        onClose={() =>
          setSelectedInfluencer({ visible: false, props: undefined })
        }
      >
        {selectedInfluencer.props?.creatorInfo && (
          <SocialMediaInfluencerComp
            creatorInfo={selectedInfluencer.props?.creatorInfo}
            socialMediaInfluencerReq={{
              username: {
                platform: selectedInfluencer.props?.platform || "",
                socialMediaUsername: selectedInfluencer.props?.username || "",
              },
              toOpenInfluencer: selectedInfluencer.props?.toOpenInfluencer,
            }}
          />
        )}
      </Drawer>

      {/* <Modal
        title={"View Deliverable"}
        open={deliverableModalProps.visible}
        onCancel={() =>
          setDeliverableModalProps({
            visible: false,
            type: "create",
            deliverableId: "",
            briefInfluencerIds: [],
          })
        }
        footer={null}
        width={1000}
        destroyOnClose
      >
        {deliverableModalProps.visible && (
          <>
            <DeliverablePackageCard
              briefId={briefId}
              defaultDeliverableId={brief?.defaultDeliverableV2Id}
              showMarkDefaultButton
              onClose={() =>
                setDeliverableModalProps({
                  visible: false,
                  type: "create",
                  deliverableId: "",
                  briefInfluencerIds: [],
                })
              }
              deliverableId={deliverableModalProps.deliverableId || ""}
            />
          </>
        )}
      </Modal> */}

      <Modal
        open={pricingPocModalProps.visible}
        onCancel={() =>
          setPricingPocModalProps({
            visible: false,
            briefInfluencerId: [],
            selectedAssignedTo: undefined,
          })
        }
        footer={null}
        title="Assign Pricing POC"
        destroyOnClose
      >
        {pricingPocModalProps.visible && (
          <AssignPricingModal
            briefInfluencerId={pricingPocModalProps.briefInfluencerId}
            assignedTo={pricingPocModalProps.selectedAssignedTo}
            onConfirm={(
              briefInfluencerId: string[],
              assignedToUserId: string
            ) =>
              assignPricingPoc({
                briefInfluencerId,
                assignedToUserId,
              })
            }
            confirmLoading={isAssigning}
            onCancel={() =>
              setPricingPocModalProps({
                visible: false,
                briefInfluencerId: [],
                selectedAssignedTo: undefined,
              })
            }
          />
        )}
      </Modal>

      <Modal
        title={"Verify Contact"}
        open={conatcsModalProps.visible}
        onCancel={() =>
          setContactsModalProps({
            visible: false,
            briefInfluencerId: "",
            creatorInfo: undefined,
            conatcts: [],
            initialContact: null,
          })
        }
        footer={null}
        width={800}
        destroyOnClose
      >
        {conatcsModalProps.visible && conatcsModalProps.creatorInfo && (
          <SelectContact
            initialContact={conatcsModalProps.initialContact}
            briefInfluencerId={conatcsModalProps.briefInfluencerId || ""}
            onSuccess={(briefInfluencer: IBriefInfluencerV2) => {
              if (!conatcsModalProps.addContactOnly) {
                setInfluencerModalProps({
                  visible: true,
                  briefInfluencer: briefInfluencer,
                  type: "create",
                });
              }
            }}
            onClose={() =>
              setContactsModalProps({
                visible: false,
                briefInfluencerId: "",
                creatorInfo: undefined,
                conatcts: [],
                addContactOnly: false,
                initialContact: null,
              })
            }
            creatorInfo={conatcsModalProps.creatorInfo}
          />
        )}
      </Modal>

      <Modal
        title={
          infCommercialsModalProps.type === "create"
            ? "Create Influnencer Commericals"
            : infCommercialsModalProps.type === "view"
              ? "Edit Influnencer Commericals"
              : "Add new Influnencer Commericals"
        }
        open={infCommercialsModalProps.visible}
        onCancel={() =>
          setInfluencerModalProps({
            visible: false,
            type: "create",
            briefInfluencer: undefined,
          })
        }
        footer={null}
        width={800}
        destroyOnClose
      >
        {infCommercialsModalProps.visible &&
          infCommercialsModalProps.briefInfluencer && (
            <InfluencerCommercial
              onClose={() =>
                setInfluencerModalProps({
                  visible: false,
                  type: "create",
                  briefInfluencer: undefined,
                })
              }
              briefInfluencer={infCommercialsModalProps.briefInfluencer}
              type={infCommercialsModalProps.type}
            />
          )}
      </Modal>
      <Modal
        title={
          brandCommercialsModalProps.type === "view"
            ? "Edit brand Commericals"
            : "Add new brand Commericals"
        }
        open={brandCommercialsModalProps.visible}
        onCancel={() =>
          setBrandluencerModalProps({
            visible: false,
            type: "view",
            briefInfluencer: undefined,
          })
        }
        footer={null}
        width={800}
        destroyOnClose
      >
        {brandCommercialsModalProps.visible &&
          brandCommercialsModalProps.briefInfluencer && (
            <BrandCommercial
              onClose={() =>
                setBrandluencerModalProps({
                  visible: false,
                  type: "view",
                  briefInfluencer: undefined,
                })
              }
              briefInfluencer={brandCommercialsModalProps.briefInfluencer}
              type={brandCommercialsModalProps.type}
            />
          )}
      </Modal>

      <Modal
        title={"Confirm Purchase"}
        open={purchaseModalProps.visible}
        onCancel={() =>
          setPurhcaseModalProps({
            visible: false,

            briefInfluencers: undefined,
          })
        }
        okText="Confirm Purchase"
        okButtonProps={{
          type: "primary",
          loading: isPurchasing,
        }}
        width={800}
        destroyOnClose
        onOk={() => {
          if (purchaseModalProps.briefInfluencers?.length) {
            purchase(
              purchaseModalProps.briefInfluencers.map((item) => item._id)
            );
          }
        }}
      >
        {purchaseModalProps.visible &&
          purchaseModalProps.briefInfluencers?.length && <ConfirmPurchase />}
      </Modal>

      <Modal
        open={showCannotPurchaseModal}
        title="Cannot purchase"
        onCancel={() => setShowCannotPurchaseModal(false)}
        footer={
          <Button onClick={() => setShowCannotPurchaseModal(false)}>
            Okay
          </Button>
        }
      >
        {purchaseResult?.result.map(({ status, reason, briefInfluencer }) => (
          <div key={briefInfluencer._id} style={{ marginBottom: 16 }}>
            <b>{briefInfluencer.influencerName} cannot be purchased</b>
            <div>{reason}</div>
          </div>
        ))}
      </Modal>
      {/* NON_PROFITABLE Modal */}
      <Modal
        open={showNonProfitableModal}
        title="Non Profitable Deal"
        onCancel={() => setShowNonProfitableModal(false)}
        okButtonProps={{
          type: "primary",
          loading: isPurchasingNonProfitable,
        }}
        onOk={async () => {
          if (purchaseResult?.result?.length) {
            for (const { briefInfluencer } of purchaseResult.result) {
              await purchaseNonProfitable(briefInfluencer._id);
            }
          }
        }}
      >
        {purchaseResult?.result.map(({ status, reason, briefInfluencer }) => (
          <div key={briefInfluencer._id} style={{ marginBottom: 16 }}>
            <div>Brand Price is {briefInfluencer.brandCost?.cost}</div>
            <div>
              Influencer Commercials is{" "}
              {briefInfluencer.brandCost?.influencerCost?.cost}
            </div>
            <div>Revenue is {briefInfluencer?.brandCost?.revenue}</div>
            <b>Are you sure you want to make this purchase?</b>
          </div>
        ))}
      </Modal>
    </>
  );
}
